import React, { useState } from 'react';
import axios from 'axios';
import '../assets/PositiveLeadForm.css';

export default function PositiveLeads() {
    const [formData, setFormData] = useState({
        customer_name: '',
        phone_number: '',
        call_date: '',
        project_name: '',
        call_status: '',
        follow_up_date: '',
        customer_reference: '',
        telesales_executive: '',
        call_notes: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.customer_name.trim()) newErrors.customer_name = 'Customer name is required';
        if (!formData.phone_number.trim()) newErrors.phone_number = 'Phone number is required';
        if (!formData.call_date) newErrors.call_date = 'Call date is required';
        if (!formData.call_status) newErrors.call_status = 'Call status is required';
        if (!formData.customer_reference) newErrors.customer_reference = 'Reference of Customer is required';
        if (!formData.telesales_executive) newErrors.telesales_executive = 'Please select Tele-Sales Executive';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        axios.post('https://www.samriddhidevelopers.in/backend/positiveleads.php', formData)
            .then(() => {
                setSubmitted(true);
                setFormData({
                    customer_name: '',
                    phone_number: '',
                    call_date: '',
                    project_name: '',
                    call_status: '',
                    follow_up_date: '',
                    customer_reference: '',
                    telesales_executive: '',
                    call_notes: '',
                });
                setTimeout(() => setSubmitted(false), 4000);
            })
            .catch((err) => console.error('Submission failed:', err))
            .finally(() => setLoading(false));
    };

    return (
        <div className="positive-leads-form-container">
            <h2 className="positive-leads-form-title">Daily Positive Calling</h2>
            <form onSubmit={handleSubmit} className="positive-leads-form">

                <div className="positive-leads-form-group">
                    <label>Customer Name *</label>
                    <input type="text" name="customer_name" value={formData.customer_name} onChange={handleChange} required />
                    {errors.customer_name && <span className="error-text">{errors.customer_name}</span>}
                </div>

                <div className="positive-leads-form-group">
                    <label>Phone Number *</label>
                    <input type="tel" name="phone_number" value={formData.phone_number} onChange={handleChange} required />
                    {errors.phone_number && <span className="error-text">{errors.phone_number}</span>}
                </div>

                <div className="positive-leads-form-group">
                    <label>Date of Call *</label>
                    <input type="date" name="call_date" value={formData.call_date} onChange={handleChange} required />
                    {errors.call_date && <span className="error-text">{errors.call_date}</span>}
                </div>

                <div className="positive-leads-form-group">
                    <label>Project Interested In</label>
                    <select name="project_name" value={formData.project_name} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="Lonavalley">Lonavalley</option>
                        <option value="PMAY-dhayari">Dhayari-PMAY</option>
                        <option value="PMAY-kirkatwadi">Kirkatwadi-PMAY</option>
                        <option value="Waterscape-p1">Waterscape phase-1</option>
                        <option value="Waterscape-p2">Waterscape phase-2</option>
                        <option value="Waterscape-p3">Waterscape phase-3</option>
                        <option value="Velhe">Velhe Riviera-greens</option>
                        <option value="Blue Horizon">Blue Horizon</option>
                        <option value="Kokan Samriddhi">Kokan Samriddhi</option>
                    </select>
                </div>

                <div className="positive-leads-form-group">
                    <label>Call Status *</label>
                    <select name="call_status" value={formData.call_status} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Interested - Office Visit Planned">Interested – Office Visit Planned</option>
                        <option value="Interested - Site Visit Planned">Interested – Site Visit Planned</option>
                        <option value="Not Interested">Not Interested</option>
                        <option value="Follow-up Later">Follow-up Later</option>
                    </select>
                    {errors.call_status && <span className="error-text">{errors.call_status}</span>}
                </div>

                <div className="positive-leads-form-group">
                    <label>Follow-up Date</label>
                    <input type="date" name="follow_up_date" value={formData.follow_up_date} onChange={handleChange} />
                </div>

                <div className="positive-leads-form-group">
                    <label>Reference of Customer *</label>
                    <select name="customer_reference" value={formData.customer_reference} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Expo">Expo</option>
                        <option value="CP">CP</option>
                        <option value="Personal">Personal</option>
                        <option value="Hoarding">Hoarding</option>
                        <option value="Paper Ad">Paper Ad</option>
                        <option value="LinkedIn">LinkedIn</option>
                        <option value="MagicBricks">MagicBricks</option>
                        <option value="99acres">99acres</option>
                        <option value="Other">Other</option>
                    </select>
                    {errors.customer_reference && <span className="error-text">{errors.customer_reference}</span>}
                </div>

                <div className="positive-leads-form-group">
                    <label>Called By Tele-Sales Executive *</label>
                    <select name="telesales_executive" value={formData.telesales_executive} onChange={handleChange} required>
                        <option value="">Select</option>
                        <option value="Gauri">Gauri</option>
                        <option value="Ranjana">Ranjana</option>
                        <option value="Smita">Smita</option>
                        <option value="Shalini">Shalini</option>
                        <option value="Sarika">Sarika</option>
                        <option value="Shravani">Shravani</option>
                        <option value="Rutuja">Rutuja</option>
                        <option value="Sayali">Sayali</option>
                        <option value="Vaishali">Vaishali</option>
                        <option value="Shubhangi">Shubhangi</option>
                        <option value="Pooja">Pooja</option>
                        <option value="Priti">Priti</option>
                        <option value="Sonali">Sonali</option>
                        <option value="Ajay">Ajay</option>
                        <option value="Namdev">Namdev</option>
                        <option value="Sopan">Sopan</option>
                        <option value="Yogesh">Yogesh</option>
                        <option value="Sagar">Sagar</option>
                        <option value="Kantak">Kantak</option>
                        <option value="Unassigned">Unassigned</option>
                    </select>
                    {errors.telesales_executive && <span className="error-text">{errors.telesales_executive}</span>}
                </div>

                <div className="positive-leads-form-group">
                    <label>Call Notes</label>
                    <textarea name="call_notes" value={formData.call_notes} onChange={handleChange} rows="4" placeholder="What was discussed during the call?" />
                </div>

                <div className="positive-leads-form-submit">
                    <button type="submit" disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit Lead'}
                    </button>
                    {submitted && <p className="positive-leads-success-message">Lead submitted successfully!</p>}
                </div>
            </form>
        </div>
    );
}
